import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface JobLinkRefDTO {
  vacanteId: number;
  titulo: string;
  empresa: string;
  idCategoria: number;
  categoriaNombre: string;
  url: string;
}

export interface PublishResultDTO {
  published: boolean;
  publishedAt?: string;
  externalId?: string;
  externalUrl?: string;
  errorMessage?: string;
}

export interface SocialPostDTO {
  id: string;
  createdAt: string;
  status: string;
  origen: string;
  anguloVenta: string;
  promotionalOnly: boolean;
  titulo: string;
  copyText: string;
  wpContentHtml?: string;
  ordenHerramientas?: string[];
  jobLinks: JobLinkRefDTO[];
  imagePrompt?: string;
  imageBase64?: string;
  wordpressMediaUrl?: string;
  scrapeRunId?: number;
  usedFallbackRun?: boolean;
  wordpress?: PublishResultDTO;
  facebook?: PublishResultDTO;
  instagram?: PublishResultDTO;
  linkedin?: PublishResultDTO;
}

@Injectable({ providedIn: 'root' })
export class AdminSocialService {

  private base = `${environment.baseApi}/admin/social`;

  constructor(private http: HttpClient) {}

  generarPreview(): Observable<any> {
    return this.http.post(`${this.base}/preview`, {});
  }

  publicar(id: string, wordpress: boolean, facebook: boolean, instagram: boolean, linkedin: boolean): Observable<any> {
    return this.http.post(`${this.base}/${id}/publish`, { wordpress, facebook, instagram, linkedin });
  }

  historial(page = 0, size = 20): Observable<any> {
    return this.http.get(`${this.base}/history?page=${page}&size=${size}`);
  }

  detalle(id: string): Observable<any> {
    return this.http.get(`${this.base}/${id}`);
  }
}
